module.exports = __webpack_public_path__ + "images/529066e52826c389abb6df47292c86a2-illu_dir_keychain.png";